// import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
// import { Field, reduxForm } from 'redux-form';
// import IconField from '../../Shared/IconField';
// import { resetPasswordValidations } from '../../../validations';
// import { submitResetPassword } from '../../../submit';

// class Form extends Component {
//     render() {
//         const { handleSubmit, submitting } = this.props;
//         const disableSubmitButton = submitting;
//         return (
//             <form onSubmit={handleSubmit}>
//                 <div className="form-group mb-3">
//                     <Field
//                         name="username"
//                         className="form-control"
//                         component={IconField}
//                         type="text"
//                         icon="ni-circle-08"
//                     />
//                 </div>
//                 <div className="text-center">
//                     <button
//                         type="submit"
//                         disabled={disableSubmitButton}
//                         className="btn btn-danger my-4"
//                     >Recuperar Acesso</button>
//                 </div>
//                 <div className="text-center">
//                     <Link to="/login" className="text-muted">
//                         <small>Já tem uma senha?</small>
//                     </Link>
//                 </div>
//             </form>
//         );
//     }
// }


// const form = reduxForm({
//     form: 'resetPassword',
//     validate: resetPasswordValidations,
//     // destroyOnUnmount: false,
//     onSubmit: submitResetPassword
// })(Form);

// export default form;

import React from 'react';

export default (<div />);


// WEBPACK FOOTER //
// ./src/components/Pages/ResetPassword/Form.js